import { render } from "./UnpublishedArticles.vue?vue&type=template&id=63ff54c8&scoped=true"
import script from "./UnpublishedArticles.vue?vue&type=script&lang=js"
export * from "./UnpublishedArticles.vue?vue&type=script&lang=js"

import "./UnpublishedArticles.vue?vue&type=style&index=0&id=63ff54c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63ff54c8"

export default script